import { Component, OnInit } from '@angular/core';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { UtilityService } from '../../../core/services/utility.service';

interface ExternalLink {
  company: number;
  link: string;
  text?: string;
}

@Component({
  selector: 'app-external-links',
  templateUrl: './external-links.component.html',
  styleUrl: './external-links.component.scss',
})
export class ExternalLinksComponent implements OnInit {
  portalSettings: any;
  employeeInfo: any;
  filteredExternalLinks: ExternalLink[] = [];

  constructor(
    portalSettingsService: PortalSettingsService,
    employeeInfoService: EmployeeInfoService,
    private utilityService: UtilityService
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {
    const externalLinks: string = this.portalSettings.ExternalLinksByCompany.ConfigValue;
    if (externalLinks) {
      this.filteredExternalLinks = this.filterExternalLinks(externalLinks);
    }
  }

  filterExternalLinks(externalLinks: string): ExternalLink[] {
    return externalLinks
      .split(';')
      .map(record => record.trim().split(','))
      .filter(([company, link]) => company && this.utilityService.isValidURL(link) && Number(company) == this.employeeInfo.PRCo)
      .map(([company, link, text = null]) => ({ company: Number(company), link, text }));
  }
}
